import type { ComponentStyleConfig } from '@chakra-ui/theme';
import { BorderWidths, Radii, Shadows, Colors, FontSizes, Space } from '../../types';

export const Alert: ComponentStyleConfig = {
  parts: ['container', 'icon', 'title', 'description'],
  baseStyle: {
    container: {
      borderWidth: BorderWidths.XS,
      borderRadius: Radii.XL,
      boxShadow: Shadows.XS,
      width: '100%',
      fontSize: FontSizes.MD,
      padding: Space.SM,
      backgroundClip: 'padding-box',
    },
    icon: {
      margin: 0,
      boxSize: '5',
      display: 'grid',
      placeItems: 'center',
    },
    title: {
      color: Colors.TEXT_EMPHASIS,
    },
    description: {
      color: Colors.TEXT_EMPHASIS,
    },
  },
  variants: {
    success: {
      container: {
        background: Colors.SURFACE_SUCCESS_SUBDUED,
        borderColor: Colors.SURFACE_SUCCESS_MUTED,
      },
      icon: {
        color: Colors.ICON_SUCCESS,
      },
    },
    error: {
      container: {
        background: Colors.SURFACE_ERROR_SUBDUED,
        borderColor: Colors.SURFACE_ERROR_MUTED,
      },
      icon: {
        color: Colors.ICON_ERROR,
      },
    },
    info: {
      container: {
        background: Colors.SURFACE_INFO_SUBDUED,
        borderColor: Colors.SURFACE_INFO_MUTED,
      },
      icon: {
        color: Colors.ICON_INFO,
      },
    },
    warning: {
      container: {
        background: Colors.SURFACE_WARNING_SUBDUED,
        borderColor: Colors.SURFACE_WARNING_MUTED,
      },
      icon: {
        color: Colors.ICON_WARNING,
      },
    },
    neutral: {
      container: {
        background: Colors.SURFACE_NEUTRAL_SUBDUED,
        borderColor: Colors.SURFACE_NEUTRAL_MUTED,
      },
      icon: {
        color: Colors.ICON_DEFAULT,
      },
    },
  },
};
